import styled from 'styled-components';

import { getDimension } from 'styled/helpers/getDimension';

export const Input = styled.input`
  margin-right: ${getDimension('size2')};
  accent-color: ${props => props.theme.colors.primary};
`;
